import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentDispatchPlaces(id: number, fields: readonly string[]) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getEnrollmentDispatchPlaces.url, { id }),
        { fields }
      )
    )
    .get<unknown[]>()
}
